module.exports = __webpack_public_path__ + "img/asian-vegetables-1.29c64838.jpg";